import { render, staticRenderFns } from "./integraldetail.vue?vue&type=template&id=471cf650&scoped=true&"
import script from "./integraldetail.vue?vue&type=script&lang=js&"
export * from "./integraldetail.vue?vue&type=script&lang=js&"
import style0 from "./integraldetail.vue?vue&type=style&index=0&id=471cf650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471cf650",
  null
  
)

export default component.exports